import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

interface ConfirmationDialogueProps {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  title?: string;
  onConfirm: () => void;
  description: string;
}

// Reusable delete confirmation dialog with TypeScript
const ConfirmationDialogue: React.FC<ConfirmationDialogueProps> = ({
  open,
  onClose,
  onConfirm,
  description,
  title,
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          width: "30%",
          maxWidth: "650px",
          borderRadius: "15px",
          backgroundColor: "#F6F7FD",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="body1" component="div" align="center">
          {`${title ?? ""}`}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: (theme) => theme.palette.error.light,
        }}
      >
        <img alt="Close icon" src="/x.png" />
      </IconButton>
      <DialogContent>
        <Typography sx={{ color: "black" }}>{description}</Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={onConfirm}
          color="success" // Green for the "Yes" button
          fullWidth
          loading={loading}
          sx={{
            textTransform: "none",
            borderRadius: "55px",
            margin: 2,
            backgroundColor: "#4CAF50", // Green background
            color: "#fff", // White text
            "&:hover": {
              backgroundColor: "#45A049", // Darker green on hover
            },
          }}
        >
          Confirm
        </LoadingButton>
        <Button
          onClick={onClose}
          fullWidth
          sx={{
            textTransform: "none",
            borderRadius: "55px",
            margin: 2,
            backgroundColor: (theme) => theme.palette.grey[300], // Grey background
            color: (theme) => theme.palette.text.primary, // Default text color
            "&:hover": {
              backgroundColor: (theme) => theme.palette.grey[400], // Darker grey on hover
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialogue;
